// @ts-nocheck
import {
    MONITORING_SPORTS_RECEIVED,
    MONITORING_EVENTS_RECEIVED,
    MONITORING_SPORTS_FETCHING,
    MONITORING_EVENTS_FETCHING,
    MONITORING_EVENT_RECEIVED,
    MONITORING_EVENT_FETCHING,
    MONITORING_LEAGUE_REMOVED,
    MONITORING_EVENTS_UPDATED,
    MONITORING_EVENT_HISTORY_RECEIVED,
    MONITORING_EVENT_HISTORY_CHANGED,
    MONITORING_BET_INFORMATION_CHANGED,
    MONITORING_BET_INFORMATION_RECEIVED,
    MONITORING_RISK_DETAILS_CHANGED,
    MONITORING_RISK_DETAILS_RECEIVED,
    MONITORING_DATES_CHANGED,
    MONITORING_FILTERS_CHANGED,
    EVENT_MARKETS_UPDATED,
    MARKETS_FILTERS_CHANGED,
    MONITORING_SET_SELECTED_SPORTID,
    MONITORING_OUTRIGHT_EVENTS_RECEIVED,
    MONITORING_OUTRIGHT_EVENTS_UPDATED,
    MONITORING_OUTRIGHT_EVENTS_FETCHING,
    MONITORING_OUTRIGHT_LEAGUE_REMOVED,
} from '../types';

const initialState = {
    sports: {
        list: [],
        isFetching: false,
    },
    events: {
        list: [],
        isFetching: false,
    },
    outrightEvents: {
        list: [],
        isFetching: false,
    },
    currentEvent: {},
    currentEventFetching: false,
    eventHistory: {
        isVisible: false,
        id: null,
        data: [],
    },
    betInformation: {
        isVisible: false,
        eventId: null,
        type: null,
        marketRefId: null,
        data: [],
    },
    riskDetails: {
        isVisible: false,
        eventId: null,
        type: null,
        data: [],
    },
    dateRange: {
        startDate: null,
        endDate: null,
    },
    filters: {
        query: '',
        status: null,
        mbn: null,
    },
    marketFilters: {
        query: '',
        status: null,
    },
    selectedSportId: '',
};

const reports = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case MONITORING_SPORTS_RECEIVED: {
            return {
                ...state,
                sports: {
                    ...state.sports,
                    list: payload,
                },
            };
        }
        case MONITORING_EVENTS_RECEIVED: {
            return {
                ...state,
                events: {
                    ...state.events,
                    list: payload,
                },
            };
        }
        case MONITORING_EVENTS_UPDATED: {
            const newList = [...state.events.list];
            payload.forEach(receivedItem => {
                if (!newList.find(existingItem => existingItem.id === receivedItem.id)) newList.push(receivedItem);
            });
            return {
                ...state,
                events: {
                    ...state.events,
                    list: newList,
                },
            };
        }
        case MONITORING_LEAGUE_REMOVED: {
            const newList = state.events.list.filter(event => event.id !== payload);
            return {
                ...state,
                events: {
                    ...state.events,
                    list: newList,
                },
            };
        }
        case MONITORING_OUTRIGHT_LEAGUE_REMOVED: {
            const newList = state.outrightEvents.list.filter(event => event.categoryId !== payload);

            return {
                ...state,
                outrightEvents: {
                    ...state.outrightEvents,
                    list: newList,
                },
            };
        }
        case MONITORING_OUTRIGHT_EVENTS_RECEIVED: {
            return {
                ...state,
                outrightEvents: {
                    ...state.outrightEvents,
                    list: payload,
                },
            };
        }
        case MONITORING_OUTRIGHT_EVENTS_UPDATED: {
            const newList = [...state.outrightEvents.list];
            payload.forEach(receivedItem => {
                if (!newList.find(existingItem => existingItem.id === receivedItem.id)) newList.push(receivedItem);
            });
            return {
                ...state,
                outrightEvents: {
                    ...state.outrightEvents,
                    list: newList,
                },
            };
        }
        case MONITORING_SPORTS_FETCHING: {
            return {
                ...state,
                sports: {
                    ...state.sports,
                    isFetching: payload,
                },
            };
        }
        case MONITORING_EVENT_RECEIVED: {
            return {
                ...state,
                currentEvent: payload,
            };
        }
        case MONITORING_EVENT_FETCHING: {
            return {
                ...state,
                currentEventFetching: payload,
            };
        }
        case MONITORING_EVENTS_FETCHING: {
            return {
                ...state,
                events: {
                    ...state.events,
                    isFetching: payload,
                },
            };
        }
        case MONITORING_OUTRIGHT_EVENTS_FETCHING: {
            return {
                ...state,
                outrightEvents: {
                    ...state.outrightEvents,
                    isFetching: payload,
                },
            };
        }
        case EVENT_MARKETS_UPDATED: {
            return {
                ...state,
                currentEvent: { ...state.currentEvent, markets: payload },
            };
        }
        case MONITORING_EVENT_HISTORY_CHANGED: {
            return {
                ...state,
                eventHistory: {
                    isVisible: payload.isVisible,
                    id: payload.eventId,
                    data: [],
                },
            };
        }
        case MONITORING_EVENT_HISTORY_RECEIVED: {
            return {
                ...state,
                eventHistory: {
                    ...state.eventHistory,
                    data: payload,
                },
            };
        }
        case MONITORING_RISK_DETAILS_CHANGED: {
            return {
                ...state,
                riskDetails: {
                    isVisible: payload.isVisible,
                    eventId: payload.eventId,
                    type: payload.type,
                    data: [],
                },
            };
        }
        case MONITORING_RISK_DETAILS_RECEIVED: {
            return {
                ...state,
                riskDetails: {
                    ...state.riskDetails,
                    data: payload,
                },
            };
        }
        case MONITORING_BET_INFORMATION_CHANGED: {
            return {
                ...state,
                betInformation: {
                    isVisible: payload.isVisible,
                    eventId: payload.eventId,
                    type: payload.type,
                    marketRefId: payload.marketRefId,
                    data: [],
                },
            };
        }
        case MONITORING_BET_INFORMATION_RECEIVED: {
            return {
                ...state,
                betInformation: {
                    ...state.betInformation,
                    data: payload,
                },
            };
        }
        case MONITORING_DATES_CHANGED: {
            return {
                ...state,
                dateRange: payload,
            };
        }
        case MONITORING_FILTERS_CHANGED: {
            return {
                ...state,
                filters: {
                    ...state.filters,
                    ...payload,
                },
            };
        }
        case MARKETS_FILTERS_CHANGED: {
            return {
                ...state,
                marketFilters: {
                    ...state.marketFilters,
                    ...payload,
                },
            };
        }
        case MONITORING_SET_SELECTED_SPORTID: {
            return {
                ...state,
                selectedSportId: payload,
            };
        }
        default:
            return state;
    }
};

export default reports;
